import { BASE_URL, EXTENSION_APPROVAL_LIST, GET,  } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from '../../authActions/authActions';

export const fetchAccountAccessApprovalList = async (next) => {
  const token = await getAccessToken();
  let url = `${BASE_URL}${EXTENSION_APPROVAL_LIST}`;

let array = [
  {
    key:"next",
    value:next
  } // download true
]  

let queryString=``;
array.forEach((item)=>{
  if(item.value){
    if(queryString){
      queryString=queryString+`&${item.key}=${item.value}`
    }else{
      queryString=`${item.key}=${item.value}`
    }
  }
})
if(queryString){
  url=`${url}?${queryString}`;
  url = url.replace ("filter=&", "");
}
  return fetch(url, {
    method: GET,
    headers: {
      "Content-Type": "application/json",
      userAuth: `bearer ${token}`,
    },
  })
    .then(statusParsing)
    .then(jsonParsing);
};
